import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
// import { AuthService } from 'app/shared/auth/auth.service';
import { HelperService } from 'app/shared/services/helper.service';
import * as moment from 'moment';
import { NgModule } from '@angular/core';


@Component({
  selector: 'app-preview-card',
  templateUrl: './preview-card.component.html',
  styleUrls: ['./preview-card.component.scss']
})

export class PreviewCardComponent implements AfterViewInit {
  @ViewChild('canvas', { static: false }) canvasRef: ElementRef;
  private context: CanvasRenderingContext2D;
  private imageLoaded: boolean = false;

  openPopup = false;
  moment = moment;
  img_path = '../../../../assets/img/S-233_001.jpg';

  textName = '';
  constructor(
    private helperService: HelperService,
    @Inject(DOCUMENT) private document: Document,
  private _helperService: HelperService,
    ) {
  }

  ngAfterViewInit() {
    const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;
    this.context = canvas.getContext('2d');
    const image = new Image();
    image.src = this.img_path;
    image.onload = () => {
      // this.context.drawImage(image, 0, 0);
      this.drawImageOnCanvas(image);
      this.imageLoaded = true;
      //this.openModal();
    };
  }

  drawImageOnCanvas(image: HTMLImageElement) {
    const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
  
  
    // Set the canvas rendering size to improve image quality
    canvas.style.width = canvasWidth + 'px';
    canvas.style.height = canvasHeight + 'px';
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
   
  
    // Draw the image using drawImage with additional parameters
    this.context.drawImage(
      image,
      0, 0, image.width, image.height, // Source image dimensions
      0, 0, canvasWidth, canvasHeight // Destination canvas dimensions
    );
  }
  
  

  drawTextOnImage(text) {
    if (this.imageLoaded) {
      this.context.font = '20px NeoSansArabicBold';
      this.context.fillStyle = '#0e6835';
      this.context.fillText(text, 210, 745);
    }
  }

  downloadImage() {
    const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;
    const link = document.createElement('a');
    link.href = canvas.toDataURL();
    link.download = 'modified_image.png';
    link.click();
  }

  // On submit button click
  async Print(text) {
    try {
      this.drawTextOnImage(text);
      this.openModal();
      //this.downloadImage();
    } catch (err) {
      
    }
  }

  resetCanvas(newImagePath: string) {
    const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;
    const context: CanvasRenderingContext2D = canvas.getContext('2d');
  
    // Clear the entire canvas
    context.clearRect(0, 0, canvas.width, canvas.height);
  
    // Load and draw the new image
    const image = new Image();
    image.src = newImagePath;
    image.onload = () => {
      this.drawImageOnCanvas(image);
    };
  }

  openModal() {
    this.openPopup = true;
    this.document.body.classList.add('openPopup');
   
   
  }

  closeModal() {
    this.openPopup = false;
    this.document.body.classList.remove('openPopup');
    this.resetCanvas(this.img_path);
  }

}
